import React from 'react';
import ReactDOM from 'react-dom/client';

import { Analytics } from '@vercel/analytics/react';
import { initAnalytics } from './analytics/posthog';
import './index.css';
import './i18n';
import App from './App';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <App />
        <Analytics/>
    </>
);